import Grid from "@mui/material/Grid"
import styleCss from "../Style/style"
import Container from "@mui/material/Container"
import Typography from "@mui/material/Typography"
import Tabs from "@mui/material/Tabs"
import { useState } from "react"
import Tab from "@mui/material/Tab"
import { Box } from '@mui/material';
import BookingHistory from "./BookingHistory"
import MyProfile from "./MyProfile"
import CoPassanger from "./CoPassenger"
import Preference from "./Preference"
import { useLocation } from "react-router-dom"


const MyAccount = () => {
    const location = useLocation();
    const { tabValue } = location.state || {};

    const [value, setValue] = useState(tabValue !== undefined ? tabValue : 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <Box sx={{
                        margin: '0 auto', width: '85%',
                        "@media (max-width:600px)": {
                            width: '100%',
                        },
                    }}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#1d1d1d',
                                }}>
                                    My Profile
                                </Typography>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '15px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#364252',
                                    marginBottom: '30px',
                                    height: 'unset',
                                }}>
                                    Manage your account and booking preferences
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Box
                                    sx={{
                                        bgcolor: "#f0f0f0",
                                        borderRadius: "30px",
                                        display: "block",
                                        padding: '10px 8px',
                                        marginBottom: '30px',
                                        "@media (max-width:600px)": {
                                            padding: '25px 8px',
                                        },
                                    }}
                                >

                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="fullWidth"
                                        sx={{
                                            "& .MuiTabs-flexContainer": {
                                                borderRadius: "30px",
                                                "@media (max-width:600px)": {
                                                    flexDirection: "column",
                                                    alignItems: "stretch",
                                                    gap: "8px",
                                                },
                                            },
                                            "& .MuiTab-root": {
                                                textTransform: "none",
                                                borderRadius: "30px",
                                                fontWeight: 600,
                                                color: "#364252",
                                                padding: "4px 8px",
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: "15px",
                                                "@media (max-width:600px)": {
                                                    minWidth: "100%",
                                                },
                                                "&.Mui-selected": {
                                                    bgcolor: "#fff",
                                                    color: "#364252",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "15px",
                                                },
                                            },
                                            "& .MuiTabs-indicator": { display: "none" },
                                        }}
                                    >
                                        <Tab label="Profile" />
                                        <Tab label="Co-Passengers" />
                                        <Tab label="Booking History" />
                                        <Tab label="Preferences" />
                                    </Tabs>
                                </Box>
                                {value === 0 && (
                                    <MyProfile />
                                )}
                                {value === 1 && (
                                    <CoPassanger />
                                )}
                                {value === 2 && (
                                    <Box sx={{
                                        padding: "33px 20px",
                                        borderRadius: "20px",
                                        border: "1px solid #e5e5e5",
                                        backgroundColor: "#fff",
                                        "@media (max-width:600px)": {
                                            padding: "20px 10px",
                                        },
                                    }}>
                                        <BookingHistory />
                                    </Box>
                                )}
                                {value === 3 && (
                                    <Preference />
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Grid >
        </>
    )
}

export default MyAccount